import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  scrollView: {
    flex: 1,
    paddingTop: theme.spacing[8],
  },
  scrollContent: {
    paddingBottom: theme.spacing[8],
  },
  content: {
    paddingHorizontal: theme.spacing[5],
  },
  card: {
    paddingHorizontal: theme.spacing[4],
    paddingVertical: theme.spacing[5],
    backgroundColor: colors.backgroundL1,
    borderRadius: 8,
  },
  headerContainer: {
    alignItems: 'center',
  },
  headerText: {
    flex: 1,
    lineHeight: 24,
  },
  closeButton: {
    alignSelf: 'flex-start',
  },
  // Badge: Figma uses bg-black, p-16, rounded-8, gap-16
  waitlistBadge: {
    padding: 16,
    backgroundColor: colors.backgroundInverseStatic,
    borderRadius: 8,
    flexDirection: 'column',
    gap: 16,
  },
  waitlistBadgeExpired: {
    padding: 16,
    backgroundColor: colors.backgroundInverseStatic,
    borderRadius: 8,
    flexDirection: 'column',
    gap: 16,
  },
  badgeTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
  },
  badgeTopText: {
    flex: 1,
  },
  // Position badge: Figma uses bg-[#333], rounded-8, size-48
  positionBadge: {
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: colors.backgroundL2Inverse,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeSeparator: {
    height: 1,
    backgroundColor: colors.backgroundL2Alpha,
  },
  // Notification row: Figma uses gap-11
  notifyRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 11,
  },
  bellIconContainer: {
    width: 15,
    height: 17,
  },
  notificationDot: {
    position: 'absolute',
    top: -1,
    right: -1,
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.backgroundNegative,
  },
  clockIconContainer: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: colors.backgroundL2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  expiredIconContainer: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: colors.backgroundNegativeSubtle,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeBarberRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
    marginTop: theme.spacing[3],
  },
  badgeBarberRowLg: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[4],
    marginTop: theme.spacing[6],
  },
  badgeAvatar: {
    backgroundColor: colors.backgroundL2,
  },
  badgeHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  badgeContent: {
    flex: 1,
  },
  badgeCtaButton: {
    marginTop: theme.spacing[6],
    height: 42,
    backgroundColor: colors.backgroundBrand,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
